var R={ENTER:"Enter",SPACE:" ",DOWN_ARROW:40,UP_ARROW:38};export{R as keyCodes};
